<template>
  <div id="devicePlayerPage" style="display: flex; flex-direction: column;">
    <div class="player-card">
      <div class="cell-label" v-if="showLabelResolved">
        <span :class="['status-dot', deviceOnline ? 'online' : 'offline']"></span>
        <span class="device-name">{{ deviceName || deviceId }}</span>
      </div>
      <jessibucaPlayer v-if="activePlayer === 'jessibuca'" ref="jessibuca" :visible.sync="showVideoDialog" :device-id="deviceId" :channel-id="channelId"
                       :videoUrl="videoUrl" :error="videoError" :message="videoError" height="400px"
                       :hasAudio="hasAudio" fluent loadingText=""
                       autoplay live @play="onPlayerPlay" @error="onPlayerError"></jessibucaPlayer>
      <div class="player-loading" v-if="loadingText">
        <i class="el-icon-loading"></i>
        <span class="loading-text">{{ loadingText }}</span>
      </div>
    </div>
<!--    <div class="control-panel-container" v-show="controlPanelVisible">-->
<!--&lt;!&ndash;      <div style="margin-top: 20px;width: 100%;display: flex; justify-content: center;">&ndash;&gt;-->
<!--        <div class="control-wrapper">-->
<!--          <div class="control-btn control-top" @mousedown="ptzCamera('up')" @mouseup="ptzCamera('stop')">-->
<!--            <i class="el-icon-caret-top"></i>-->
<!--            <div class="control-inner-btn control-inner"></div>-->
<!--          </div>-->
<!--          <div class="control-btn control-left" @mousedown="ptzCamera('left')" @mouseup="ptzCamera('stop')">-->
<!--            <i class="el-icon-caret-left"></i>-->
<!--            <div class="control-inner-btn control-inner"></div>-->
<!--          </div>-->
<!--          <div class="control-btn control-bottom" @mousedown="ptzCamera('down')" @mouseup="ptzCamera('stop')">-->
<!--            <i class="el-icon-caret-bottom"></i>-->
<!--            <div class="control-inner-btn control-inner"></div>-->
<!--          </div>-->
<!--          <div class="control-btn control-right" @mousedown="ptzCamera('right')" @mouseup="ptzCamera('stop')">-->
<!--            <i class="el-icon-caret-right"></i>-->
<!--            <div class="control-inner-btn control-inner"></div>-->
<!--          </div>-->
<!--          <div class="control-round">-->
<!--            <div class="control-round-inner"><i class="fa fa-pause-circle"></i></div>-->
<!--          </div>-->
<!--  &lt;!&ndash;        <div style="position: absolute; left: 7.25rem; top: 1.25rem" @mousedown="ptzCamera('zoomin')"&ndash;&gt;-->
<!--  &lt;!&ndash;             @mouseup="ptzCamera('stop')"><i class="el-icon-zoom-in control-zoom-btn"&ndash;&gt;-->
<!--  &lt;!&ndash;                                             style="font-size: 1.875rem;"></i></div>&ndash;&gt;-->
<!--  &lt;!&ndash;        <div style="position: absolute; left: 7.25rem; top: 3.25rem; font-size: 1.875rem;"&ndash;&gt;-->
<!--  &lt;!&ndash;             @mousedown="ptzCamera('zoomout')" @mouseup="ptzCamera('stop')"><i&ndash;&gt;-->
<!--  &lt;!&ndash;          class="el-icon-zoom-out control-zoom-btn"></i></div>&ndash;&gt;-->
<!--          <div class="contro-speed" style="position: absolute;left: 4px;top: 19rem;width: 18rem;">-->
<!--            <el-slider v-model="controSpeed" :max="255"></el-slider>-->
<!--          </div>-->
<!--        </div>-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->
<!--    </div>-->
<!--    <div id="shared" style="text-align: right; margin-top: 1rem;">-->
<!--      <el-tabs v-model="tabActiveName" @tab-click="tabHandleClick">-->
<!--        <el-tab-pane style="margin-left: 40%;" label="语音对讲" name="talkback">-->
<!--          <div class="talk-div" @click="talkHandle">-->
<!--            <i :class="'el-icon-microphone'" :title="talkTitle"-->
<!--               :style="{ color: microphoneStatus ? 'rgba(25, 246, 5, 0.69)' : 'rgba(118, 118, 118, 0.742)' }"-->
<!--               v-if="canTalk"></i>-->

<!--            <i :class="'el-icon-turn-off-microphone'" :title="talkTitle" v-if="!canTalk"></i>-->
<!--          </div>-->

<!--        </el-tab-pane>-->
<!--      </el-tabs>-->
<!--    </div>-->
    <!-- 在 template 中添加以下代码 -->
    <!-- 新增悬浮按钮结构 -->
<!--    <div class="floating-ctrl" @click="toggleControlPanel">-->
<!--      <i class="el-icon-setting" :style="{ color: controlPanelVisible ? '#1890ff' : '' }"></i>-->
<!--    </div>-->
<!--    <div class="floating-talkback" @click="talkHandle">-->
<!--      <i :class="microphoneStatus ? 'el-icon-microphone' : 'el-icon-turn-off-microphone'" :title="talkTitle"-->
<!--         :style="{ color: microphoneStatus ? 'rgba(25, 246, 5, 0.69)' : 'rgba(118, 118, 118, 0.742)' }"></i>-->
<!--    </div>-->
    <div>
      <div v-show="false">
        <video ref="video" controls autoplay style="text-align:left;">
        </video>
        <video ref='selfVideo' controls autoplay style="text-align:right;">
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import rtcPlayer from './dialog/rtcPlayer.vue'
import LivePlayer from '@liveqing/liveplayer'
import jessibucaPlayer from './common/jessibuca.vue'
import {debounce} from 'lodash'
import userService from "./service/UserService";
import DeviceService from "./service/DeviceService";

export default {
  name: 'devicePlayerPage',
  props: {
    username: {},
    password: {},
    // 是否显示左上角（状态灯 + 设备名）标签。
    // 仅对"组件方式调用"生效，默认显示；外部 URL 参数调用见 showLabelResolved
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  components: {
    LivePlayer, jessibucaPlayer, rtcPlayer,
  },
  computed: {
    // 是否由外部（iframe / URL 路由 /frame/devicePlay）进入
    isExternalEntry: function () {
      const route = this.$route || {};
      return route.name === 'devicePlay'
        || (typeof route.path === 'string' && route.path.indexOf('/frame/devicePlay') === 0);
    },
    // 标签可见性优先级：
    // 1) 外部 URL 显式传 ?showLabel=... 时以其为准（支持 true/false/1/0）
    // 2) 未显式传参时：外部参数方式进入默认【不显示】，组件方式调用默认【显示】（取 prop）
    showLabelResolved: function () {
      const query = (this.$route && this.$route.query) || {};
      const q = query.showLabel;
      if (q !== undefined && q !== null && q !== '') {
        return q === true || q === 'true' || q === '1' || q === 1;
      }
      return this.isExternalEntry ? false : this.showLabel;
    },
    getPlayerShared: function () {
      return {
        sharedUrl: window.location.origin + '/#/play/wasm/' + encodeURIComponent(this.videoUrl),
        sharedIframe: '<iframe src="' + window.location.origin + '/#/play/wasm/' + encodeURIComponent(this.videoUrl) + '"></iframe>',
        sharedRtmp: this.videoUrl
      };
    },
    canTalk() {
      var ishttps = 'https:' == document.location.protocol ? true : false;

      console.log("hasAudiohasAudiohasAudiohasAudio:" + this.hasAudio);
      if (!ishttps || !this.hasAudio) {
        this.talkTitle = "由于浏览器安全策略本站必须得是https，并且开启通道音频选项才可以对讲";
        return false;
      }
      this.talkTitle = "开始对讲";
      return true;
    }
  },
  created() {
    this.resetToInitialState();
    console.log(this.player)
    if (Object.keys(this.player).length === 1) {
      this.activePlayer = Object.keys(this.player)[0]
    }
    this.broadCastModel = this.broadCastOption[0].value;

  },
  mounted() {
    // 根据父容器（如 iframe）尺寸自动伸缩：观察父元素尺寸变化
    this.syncParentHeight();
    if (typeof ResizeObserver !== 'undefined' && this.$el.parentNode) {
      this.resizeObserver = new ResizeObserver(() => this.syncParentHeight());
      this.resizeObserver.observe(this.$el.parentNode);
    }
    window.addEventListener('resize', this.syncParentHeight);

    // 添加外部点击监听
    document.addEventListener('click', this.handleClickOutside);

    // 获取设备名称与在线状态，用于视频卡片左上角标签（未开启标签时跳过请求）
    if (this.showLabelResolved) {
      const deviceService = new DeviceService();
      deviceService.getDevice(this.deviceId, (res) => {
        if (res && res.code === 0 && res.data) {
          const device = res.data;
          this.deviceName = device.name || this.deviceId;
          this.deviceOnline = device.onLine;
        }
      });
    }

    // 新增屏幕方向变化监听
    window.matchMedia("(orientation: portrait)").addEventListener('change', this.handleOrientationChange);

    const that = this;
    if(this.username){
      let loginParam = {
        username: this.username,
        password: this.password
      }
      this.loadingText = '正在登录…';
      this.$axios({
        method: 'get',
        url:"/api/user/login",
        params: loginParam
      }).then(function (res) {
        console.log(res);
        console.log("登录成功");
        if (res.data.code === 0 ) {
          that.autoLogin = true;
          res.data.data.autoLogin = true;
          userService.setUser(res.data.data);
          userService.setToken(res.data.data.accessToken);
          // 发送推流请求
          that.sendDevicePush();
        }else{
          that.loadingText = '';
          that.$message({
            showClose: true,
            message: '登录失败，用户名或密码错误',
            type: 'error'
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    }

    // 添加 beforeunload 事件监听器
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    // 移除 beforeunload 事件监听器
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    // 移除监听
    document.removeEventListener('click', this.handleClickOutside);
    // 移除屏幕方向变化监听
    window.matchMedia("(orientation: portrait)").removeEventListener('change', this.handleOrientationChange);
    window.removeEventListener('resize', this.syncParentHeight);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },
  data() {
    return {
      controlPanelVisible: window.matchMedia("(orientation: portrait)").matches,
      mp3Url: null,
      fileList: [],
      headers: {
        "access-token": userService.getToken()
      },
      broadCastOption: [
        {
          value: '0',
          key: '国标对讲模式'
        },
        {
          value: '1',
          key: '大华TALK模式'
        }
      ],
      video: 'http://lndxyj.iqilu.com/public/upload/2019/10/14/8c001ea0c09cdc59a57829dabc8010fa.mp4',
      videoUrl: '',
      activePlayer: "jessibuca",
      // 如何你只是用一种播放器，直接注释掉不用的部分即可
      player: {
        jessibuca: ["ws_flv", "wss_flv"],
        livePlayer: ["ws_flv", "wss_flv"],
        webRTC: ["rtc", "rtcs"],
      },
      showVideoDialog: false,
      streamId: '',
      app: '',
      mediaServerId: '',
      convertKey: '',
      deviceId: this.$route.params.deviceId,
      channelId: this.$route.params.channelId,
      deviceName: '',
      deviceOnline: false,
      resizeObserver: null,
      tabActiveName: 'talkback',
      hasAudio: false,
      loadingRecords: false,
      recordsLoading: false,
      isLoging: false,
      loadingText: '',
      controSpeed: 30,
      timeVal: 0,
      timeMin: 0,
      timeMax: 1440,
      presetPos: 1,
      cruisingSpeed: 100,
      cruisingTime: 5,
      cruisingGroup: 0,
      scanSpeed: 100,
      scanGroup: 0,
      tracks: [],
      coverPlaying: false,
      tracksLoading: false,
      showPtz: true,
      showRrecord: true,
      tracksNotLoaded: false,
      sliderTime: 0,
      seekTime: 0,
      recordStartTime: 0,
      showTimeText: "00:00:00",
      streamInfo: null,
      talkTitle: null,
      talkStatus: false,
      microphoneStatus: false,
      talkInterval: null,
      zlmRTCClient: null,
      broadCastModel: null,
      recordTitle: "开始录音",
      recordStatus: false,
      recordColorStatus: false,
      recordColorStatusInterval: null
    };
  },
  methods: {
    resetToInitialState() {
      // 重置所有数据到初始状态
      Object.assign(this.$data, this.$options.data.call(this))
    },
    handleOrientationChange(e) {
      // 竖屏时自动显示控制面板
      this.controlPanelVisible = e.matches;
    },
    syncParentHeight() {
      const parent = this.$el && this.$el.parentNode;
      if (!parent) return;
      const h = parent.clientHeight;
      // 高度为 0 时跳过：避免在 0 尺寸下初始化播放器导致无法自动播放
      if (!h) return;
      this.$el.style.height = h + 'px';
      // 父容器尺寸变化后，通知播放器重算画布尺寸
      const player = this.$refs.jessibuca;
      if (player && typeof player.updatePlayerDomSize === 'function') {
        this.$nextTick(() => player.updatePlayerDomSize());
      }
    },
    toggleControlPanel() {
      this.controlPanelVisible = !this.controlPanelVisible;
    },
    // 新增点击外部区域关闭方法
    handleClickOutside(e) {
      const panel = document.querySelector('.control-panel-container');
      const btn = document.querySelector('.floating-ctrl');

      // 仅在横屏时允许点击外部关闭
      if (window.matchMedia("(orientation: landscape)").matches &&
          this.controlPanelVisible &&
          panel &&
          !panel.contains(e.target) &&
          !btn.contains(e.target)) {
        this.controlPanelVisible = false;
      }
    },
    //通知设备上传媒体流
    sendDevicePush: function () {
      let deviceId = this.deviceId;
      let channelId = this.channelId;
      console.log("通知设备推流1：" + deviceId + " : " + channelId);
      let that = this;
      this.loadingText = '正在请求设备推流…';
      this.$axios({
        method: 'get',
        url: '/api/play/start/' + deviceId + '/' + channelId,
        params:{
          isSubStream: false,
          userId: userService.getUser().id
        }
      }).then(function (res) {
        console.log(res)
        if (res.data.code === 0) {
          that.openDialog("media", deviceId, channelId, {
            streamInfo: res.data.data,
            hasAudio: true
          });
        }else{
          that.loadingText = '';
          that.$message.error(res.data.msg);
        }
      }).catch(function (e) {
        that.loadingText = '';
        that.isLoging = false;
        // that.$message.error("请求超时");
      });
    },
    setHead() {
      return {"access-token": UserService.getToken()}
    },
    getUrl() {
      if (process.env.BASE_API != null) {
        return window.location.href.split("#")[0] + process.env.BASE_API.replace("/", "") + `/api/talkback/sendAudioFileToDevice/${this.deviceId}/${this.channelId}/${this.streamId}`
      } else {
        return window.location.href.split("#")[0] + `api/talkback/sendAudioFileToDevice/${this.deviceId}/${this.channelId}/${this.streamId}`
      }
    },
    submitUpload() {
      this.$refs.upload.submit();

    },
    handleRemove(file, fileList) {

    },
    handlePreview(file) {

    },
    handleChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]
      }
    },
    handleSuccess(response, file, fileList) {
      console.log(response);
      if (response.code === 0) {
        this.$message({
          showClose: true,
          message: '下发成功',
          type: 'success'
        });
      } else {
        this.$message({
          showClose: true,
          message: response.msg,
          type: 'error'
        });
      }

    },
    tabHandleClick: function (tab, event) {
      console.log(tab)
      var that = this;
      that.tracks = [];
      that.tracksLoading = true;
      that.tracksNotLoaded = false;
      if (tab.name === "codec") {
        this.$axios({
          method: 'get',
          url: './zlm/' + this.mediaServerId + '/index/api/getMediaInfo?vhost=__defaultVhost__&schema=rtsp&app=' + this.app + '&stream=' + this.streamId
        }).then(function (res) {
          that.tracksLoading = false;
          if (res.data.code == 0 && res.data.tracks) {
            that.tracks = res.data.tracks;
          } else {
            that.tracksNotLoaded = true;
            that.$message({
              showClose: true,
              message: '获取编码信息失败,',
              type: 'warning'
            });
          }
        }).catch(function (e) {
        });
      }
    },
    changePlayer: function (tab) {
      console.log(this.player[tab.name][0])
      this.activePlayer = tab.name;
      this.videoUrl = this.getUrlByStreamInfo()
      console.log(this.videoUrl)
    },
    openDialog: function (tab, deviceId, channelId, param) {
      // this.tabActiveName = tab;
      this.channelId = channelId;
      this.deviceId = deviceId;
      this.streamId = "";
      this.mediaServerId = "";
      this.app = "";
      this.videoUrl = ""
      if (!!this.$refs[this.activePlayer]) {
        this.$refs[this.activePlayer].pause();
      }

      if (param.manufacture === 'Dahua') {
        this.broadCastModel = this.broadCastOption[1].value;
      }

      switch (tab) {
        case "media":
          this.play(param.streamInfo, param.hasAudio)
          break;
        case "streamPlay":
          this.tabActiveName = "media";
          this.showRrecord = false;
          this.showPtz = false;
          this.play(param.streamInfo, param.hasAudio)
          break;
        case "control":
          break;
      }
    },
    play: function (streamInfo, hasAudio) {
      this.streamInfo = streamInfo;
      this.hasAudio = hasAudio;
      this.isLoging = false;
      // this.videoUrl = streamInfo.rtc;
      this.videoUrl = this.getUrlByStreamInfo();
      this.streamId = streamInfo.stream;
      this.app = streamInfo.app;
      this.mediaServerId = streamInfo.mediaServerId;
      // 进入"建立视频连接"阶段，等待播放器首次 play 事件后关闭加载层
      this.loadingText = '正在建立视频连接…';
      this.playFromStreamInfo(false, streamInfo)
    },
    onPlayerPlay() {
      // 播放器已成功播放，关闭加载层
      this.loadingText = '';
    },
    onPlayerError(error) {
      // 播放出错时兜底关闭加载层，避免一直显示"建立视频连接"
      this.loadingText = '';
      console.error('player error:', error);
    },
    getUrlByStreamInfo() {
      console.log(this.streamInfo)
      if (location.protocol === "https:") {
        this.videoUrl = this.streamInfo[this.player[this.activePlayer][1]]
      } else {
        this.videoUrl = this.streamInfo[this.player[this.activePlayer][0]]
      }
      return this.videoUrl;

    },
    coverPlay: function () {
      var that = this;
      this.coverPlaying = true;
      this.$refs[this.activePlayer].pause()
      that.$axios({
        method: 'post',
        url: './api/play/convert/' + that.streamId
      }).then(function (res) {
        if (res.data.code === 0) {
          that.convertKey = res.data.key;
          setTimeout(() => {
            that.isLoging = false;
            that.playFromStreamInfo(false, res.data.data);
          }, 2000)
        } else {
          that.isLoging = false;
          that.coverPlaying = false;
          that.$message({
            showClose: true,
            message: '转码失败',
            type: 'error'
          });
        }
      }).catch(function (e) {
        console.log(e)
        that.coverPlaying = false;
        that.$message({
          showClose: true,
          message: '播放错误',
          type: 'error'
        });
      });
    },
    convertStopClick: function () {
      this.convertStop(() => {
        this.$refs[this.activePlayer].play(this.videoUrl)
      });
    },
    stopDevicePush: function () {
      var that = this;
      this.$axios({
        method: 'get',
        url: '/api/play/stop/' + this.deviceId + "/" + this.channelId,
        params: {
          isSubStream: false
        }
      }).then(function (res) {
        that.initData();
      }).catch(function (error) {
        if (error.response.status === 402) { // 已经停止过
          that.initData();
        } else {
          console.log(error)
        }
      });
    },
    convertStop: function (callback) {
      var that = this;
      that.$refs.videoPlayer.pause()
      this.$axios({
        method: 'post',
        url: './api/play/convertStop/' + this.convertKey
      }).then(function (res) {
        if (res.data.code == 0) {
          console.log(res.data.msg)
        } else {
          console.error(res.data.msg)
        }
        if (callback) callback();
      }).catch(function (e) {
      });
      that.coverPlaying = false;
      that.convertKey = "";
      // if (callback )callback();
    },

    playFromStreamInfo: function (realHasAudio, streamInfo) {
      this.showVideoDialog = true;
      this.hasaudio = realHasAudio && this.hasaudio;
      this.$refs[this.activePlayer].play(this.getUrlByStreamInfo(streamInfo))
    },
    handleBeforeUnload(event) {
      this.close();
      // 阻止默认行为并显示确认对话框（可选）
      // 注意：现代浏览器对自定义消息的支持有限
      event.preventDefault();
      event.returnValue = ''; // 一些旧版浏览器需要这个属性
    },
    close: function () {
      console.log('关闭视频');
      if (!!this.$refs[this.activePlayer]) {
        this.$refs[this.activePlayer].pause();
      }
      this.videoUrl = '';
      this.coverPlaying = false;
      this.showVideoDialog = false;
      // this.stopDevicePush();
      if (this.convertKey !== '') {
        this.convertStop();
      }
      this.convertKey = '';

      if (this.talkStatus) {
        this.stopTalk();
      }
      this.broadCastModel = this.broadCastOption[0].value;
    },

    copySharedInfo: function (data) {
      console.log('复制内容：' + data);
      this.coverPlaying = false;
      this.tracks = []
      let _this = this;
      this.$copyText(data).then(
        function (e) {
          _this.$message({
            showClose: true,
            message: '复制成功',
            type: 'success'
          });
        },
        function (e) {
          _this.$message({
            showClose: true,
            message: '复制失败，请手动复制',
            type: 'error'
          });
        }
      );
    },
    ptzCamera: function (command) {
      console.log('云台控制：' + command);
      let that = this;
      this.$axios({
        method: 'post',
        url: './api/ptz/control/' + this.deviceId + '/' + this.channelId + '?command=' + command + '&horizonSpeed=' + this.controSpeed + '&verticalSpeed=' + this.controSpeed + '&zoomSpeed=' + this.controSpeed
      }).then(function (res) {
      });
    },
    //////////////////////播放器事件处理//////////////////////////
    videoError: function (e) {
      console.log("播放器错误：" + JSON.stringify(e));
    },
    presetPosition: function (cmdCode, presetPos) {
      console.log('预置位控制：' + this.presetPos + ' : 0x' + cmdCode.toString(16));
      let that = this;
      this.$axios({
        method: 'post',
        url: './api/ptz/front_end_command/' + this.deviceId + '/' + this.channelId + '?cmdCode=' + cmdCode + '&parameter1=0&parameter2=' + presetPos + '&combindCode2=0'
      }).then(function (res) {
      });
    },
    setSpeedOrTime: function (cmdCode, groupNum, parameter) {
      let that = this;
      let parameter2 = parameter % 256;
      let combindCode2 = Math.floor(parameter / 256) * 16;
      console.log('前端控制：0x' + cmdCode.toString(16) + ' 0x' + groupNum.toString(16) + ' 0x' + parameter2.toString(16) + ' 0x' + combindCode2.toString(16));
      this.$axios({
        method: 'post',
        url: './api/ptz/front_end_command/' + this.deviceId + '/' + this.channelId + '?cmdCode=' + cmdCode + '&parameter1=' + groupNum + '&parameter2=' + parameter2 + '&combindCode2=' + combindCode2
      }).then(function (res) {
      });
    },
    setCommand: function (cmdCode, groupNum, parameter) {
      let that = this;
      console.log('前端控制：0x' + cmdCode.toString(16) + ' 0x' + groupNum.toString(16) + ' 0x' + parameter.toString(16) + ' 0x0');
      this.$axios({
        method: 'post',
        url: './api/ptz/front_end_command/' + this.deviceId + '/' + this.channelId + '?cmdCode=' + cmdCode + '&parameter1=' + groupNum + '&parameter2=' + parameter + '&combindCode2=0'
      }).then(function (res) {
      });
    },
    copyUrl: function (dropdownItem) {
      console.log(dropdownItem)
      this.$copyText(dropdownItem).then((e) => {
        this.$message.success("成功拷贝到粘贴板");
      }, (e) => {

      })
    },
    talkHandle() {
      // !this.talkStatus && this.canTalk
      if (!this.talkStatus && this.canTalk) {
        //下发指令成功后话筒闪烁
        if (this.talkInterval != null) {
          clearInterval(this.talkInterval)
        }
        this.talkInterval = setInterval(() => {
          this.microphoneStatus = !this.microphoneStatus;
        }, 500);
        this.stopTalk();
        this.startTalk();

      } else if (this.talkStatus === true) {
        this.stopTalk();
      }

    },
    startTalk: debounce(function () {
      var _that = this;
      this.talkStatus = true;
      //1.第一步获取webrtc推流地址
      this.$axios({
        method: 'get',
        url: `/api/talkback/getWebRtcAddr/${this.deviceId}/${this.channelId}`
      }).then(res => {

        if (res.data.code != 0) {
          this.$message({
            message: res.data.msg,
            type: "error",
          });

          this.talkStatusChange();
          return;
        }
        let webRtcPushUrl = res.data.data.webRtcPushUrl;
        let app = res.data.data.app;
        let stream = res.data.data.stream;
        //2.拿到webrtc地址先推流
        _that.zlmRTCClient = new window.ZLMRTCClient.Endpoint({
          element: _that.$refs.video,// video 标签
          debug: false,// 是否打印日志
          zlmsdpUrl: webRtcPushUrl,//流地址
          simulcast: false,
          useCamera: false,
          audioEnable: true,
          videoEnable: false,
          recvOnly: false,
          resolution: {w: 0, h: 0},
          usedatachannel: false,
        });

        _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ICE_CANDIDATE_ERROR, function (e) {// ICE 协商出错
          console.log('ICE 协商出错')
          _that.$message({
            message: e.msg,
            type: "error",
          });
          _that.talkStatusChange();
        });


        _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_OFFER_ANWSER_EXCHANGE_FAILED, function (e) {// offer anwser 交换失败
          console.log('offer anwser 交换失败', e);
          _that.$message({
            message: e.msg,
            type: "error",
          });
          if (e.msg === "already publishing") {
            _that.webrtcStop();

          }
          _that.talkStatusChange();
        });

        _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ON_LOCAL_STREAM, function (s) {// 获取到了本地流

          _that.$refs.selfVideo.srcObject = s;
          _that.$refs.selfVideo.muted = true;

          //console.log('offer anwser 交换失败',e)
        });

        _that.zlmRTCClient.on(ZLMRTCClient.Events.CAPTURE_STREAM_FAILED, function (s) {// 获取本地流失败

          console.log('获取本地流失败')
          _that.$message({
            message: "获取本地流失败,请检查是否有麦克风",
            type: "error",
          });
          _that.talkStatusChange();
        });

        _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ON_CONNECTION_STATE_CHANGE, function (state) {// RTC 状态变化 ,详情参考 https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/connectionState
          console.log('当前状态==>', state)
          if (state === "connected") {
            //推流成功开始下发语音对讲指令
            _that.$axios({
              method: 'get',
              url: `/api/talkback/start/${_that.deviceId}/${_that.channelId}/${app}/${stream}/${_that.broadCastModel}`
            }).then(res => {
              if (res.data.code !== 0) {
                _that.$message({
                  message: res.data.msg,
                  type: "error",
                });
                _that.webrtcStop();
                _that.talkStatusChange();
                return;
              } else {
                _that.$message({
                  message: "开始对讲",
                  type: "success",
                });
                _that.talkTitle = "停止对讲";
              }
              //console.log(this.el-icon-microphone);

            }).catch(error => {
              _that.$message({
                message: "对讲指令下发失败",
                type: "error",
              });
              _that.stopTalk();
            })
          } else if (state === "failed") {
            _that.$message({
              message: "webrtc推流失败，请检查流媒体配置",
              type: "error",
            });
            _that.talkStatusChange();
          }
        });

        _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ON_DATA_CHANNEL_OPEN, function (event) {
          console.log('rtc datachannel 打开 :', event)
        });

        _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ON_DATA_CHANNEL_ERR, function (event) {
          console.log('rtc datachannel 错误 :', event)
        });

        _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ON_DATA_CHANNEL_CLOSE, function (event) {
          console.log('rtc datachannel 关闭 :', event)
        });


      }).catch(res => {
        _that.talkStatusChange();

        _that.$message({
          message: res,
          type: "error",
        });

      })
    }, 500),

    stopTalk() {
      //停止对讲

      if (this.zlmRTCClient) {
        this.$message({
          message: "停止对讲",
          type: "success",
        });
        this.webrtcStop();
        // 异步调用后端API清理对讲状态，避免仅依赖ZLM hook导致状态残留
        this.$axios({
          method: 'get',
          url: `/api/talkback/stop/${this.deviceId}/${this.channelId}`
        }).then(res => {
          console.log('停止对讲响应:', res.data);
        }).catch(error => {
          console.error('停止对讲请求失败:', error);
        });
        this.talkStatusChange();
      }
    },

    talkStatusChange() {
      this.talkTitle = "开始对讲";
      this.talkStatus = false;
      clearInterval(this.talkInterval);
      this.microphoneStatus = false;
    },
    webrtcStop() {
      this.zlmRTCClient.close();
      var remote = this.$refs.video;
      if (remote) {
        remote.srcObject = null;
        remote.load();
      }
      var local = this.$refs.selfVideo;
      local.srcObject = null;
      local.load();
    },

    recordHandle() {
      if (!this.canTalk) {
        alert(this.talkTitle);
        return
      }

      this.recordStatus = !this.recordStatus;

      if (this.recordColorStatusInterval != null) {
        clearInterval(this.recordColorStatusInterval)
      }
      this.recordColorStatusInterval = setInterval(() => {
        this.recordColorStatus = !this.recordColorStatus;
      }, 500);
    }

  }
};
</script>

<style scoped>
.player-card {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: #14181f;
  border: 1px solid #2a2e36;
  border-radius: 4px;
  overflow: hidden;
}

.cell-label {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-size: 13px;
  color: #fff;
  background: rgba(0, 0, 0, 0.55);
  border-radius: 4px;
  pointer-events: none;
  max-width: calc(100% - 16px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-dot.online {
  background: #67c23a;
  box-shadow: 0 0 6px #67c23a;
}

.status-dot.offline {
  background: #f56c6c;
  box-shadow: 0 0 6px #f56c6c;
}

.device-name {
  line-height: 1.2;
}

.player-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* 低于 .cell-label，避免遮挡设备名；不拦截鼠标事件 */
  z-index: 2;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(20, 24, 31, 0.75);
  color: #fff;
  font-size: 14px;
}

.player-loading .el-icon-loading {
  font-size: 32px;
  color: #409eff;
}

.player-loading .loading-text {
  letter-spacing: 1px;
}

.trank {
  width: 80%;
  height: 180px;
  text-align: left;
  padding: 0 10%;
  overflow: auto;
}

.trankInfo {
  width: 80%;
  padding: 0 10%;
}

.talk-div {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #8080809c;
  margin-left: 200px;
  position: relative;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  font-size: 60px;
  cursor: pointer;
}

/* 在 style 标签中添加以下代码 */
.floating-talkback {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
}

.floating-talkback i {
  font-size: 24px;
}

/* 新增响应式样式 */
.floating-ctrl {
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  transition: all 0.3s ease;
}

.floating-ctrl i {
  font-size: 24px;
}

.floating-ctrl:hover {
  transform: scale(1.1);
}

.control-panel-container {
  position: fixed;
  bottom: 150px;
  right: 20px;
  z-index: 998;
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 竖屏样式 */
@media screen and (orientation: portrait) {
  .floating-ctrl {
    display: none;
  }

  .control-panel-container {
    display: flex;
    left: 0;
    right: 0;
    height: 35vh; /* 使用视口单位更灵活 */
    max-height: 40%;
    min-height: 300px;
    border-radius: 12px 12px 0 0;
    padding: 15px 0;
    background: #f8f9fa;
    backdrop-filter: blur(8px);
    border-top: 1px solid #e0e0e0;
  }

  .control-wrapper {
    position: relative;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

/* 横屏样式 */
@media screen and (orientation: landscape) {
  .control-panel-container {
    position: fixed;
    right: 20px;
    height: auto;
    width: auto;
    margin-bottom: 1rem;
    background: #fff;
    padding: 10px;
    border-radius: 8px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/devicePlayerPage.vue